import {CSSProperties, FC} from 'react';


export interface IIconArrowBackOvalAvitoProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconArrowBackOvalAvito: FC<IIconArrowBackOvalAvitoProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 12"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M5.946 2.534V.708c0-.63-.735-.945-1.164-.5l-4.2 4.35a.906.906 0 0 0 0 1.25l4.2 4.35c.43.445 1.164.13 1.164-.5V7.744c4.303 0 6.796 1.313 8.747 4.098.225.32.73.115.627-.267-1.227-4.562-4.162-8.655-9.374-9.04Z" />
        </svg>
    );
};
